// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/1f801b2e69a0f87c1716.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"1d2cb24de33ed7c19272","125":"40487a18e04d39ff9d07","126":"500847926ff491aa8810"}[chunkId] + ".chunk.js";
};